/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import { Button, Dropdown } from "react-bootstrap";
import React, { useState } from "react";
import "../../assets/styles/App.css";
import { withTranslation } from "react-i18next";
import { convertEpochToDate } from "../../utils/date";
// import { convertEpochToDate } from "../../utils/date";

/**
 * This is the component for the Add Organization modal in the Service Page. <br>
 * There are two screens in this modal, controlled by state variables. <br>
 * The first one is collect organization info, while the second is to collect user info.
 *
 * @component
 */
class CustomABHAModal extends React.Component {
  constructor(props) {
    super(props);

    this.t = props.t;
    this.i18n = props.i18n;
  }

  render() {
    const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
      <a
        href=""
        className="secondary-sites-arrow"
        ref={ref}
        onClick={e => {
          e.preventDefault();
          onClick(e);
        }}
      >
        {children}
      </a>
    ));

    const CustomMenu = React.forwardRef(
      ({ children, style, className, "aria-labelledby": labeledBy }, ref) => {
        const [value] = useState("");

        return (
          <div
            ref={ref}
            style={style}
            className={className}
            aria-labelledby={labeledBy}
          >
            <ul className="list-unstyled">
              {React.Children.toArray(children).filter(
                child =>
                  !value || child.props.children.toLowerCase().startsWith(value)
              )}
            </ul>
          </div>
        );
      }
    );
    return (
      <div className="custommodal">
        <div className="custommodalinner abha-modal">
          <form className="loginpad">
            <h6 className="modal-heading">ABHA Demographic Details</h6>
            <Button
              // eslint-disable-next-line react/prop-types
              onClick={this.props.closePopup}
              className="cancle"
            >
              {" "}
              x{" "}
            </Button>
            <hr className="hrpadding" />
            <div className="new-exam-details-patient-details demographic-details">
              <div>
                First Name:{" "}
                <span className="new-exam-details-value">
                  {this.props.patient.firstName}
                </span>
              </div>
              <div>
                Last Name:{" "}
                <span className="new-exam-details-value">
                  {this.props.patient.lastName}
                </span>
              </div>
              <div>
                Gender:{" "}
                <span className="new-exam-details-value">
                  {this.props.patient.gender}
                </span>
              </div>
              <div>
                Date of Birth:{" "}
                <span className="new-exam-details-value">
                  {convertEpochToDate(this.props.patient.dateOfBirth)}
                </span>
              </div>
              <div>
                Phone Number:{" "}
                <span className="new-exam-details-value">
                  {this.props.patient.phoneNumber}
                </span>
              </div>
              <div>
                ABHA Address:{" "}
                <span className="new-exam-details-value">
                  {this.props.patient.abhaAddress}
                  {(() => {
                    if (
                      Array.isArray(this.props.patient.otherAbhaAddresses) &&
                      this.props.patient.otherAbhaAddresses.length > 0
                    ) {
                      return (
                        <span className="secondary-sites-users">
                          <Dropdown>
                            <Dropdown.Toggle
                              as={CustomToggle}
                              id="dropdown-other-abha-addresses"
                            >
                              &nbsp;(+
                              {this.props.patient.otherAbhaAddresses.length})
                            </Dropdown.Toggle>

                            <Dropdown.Menu as={CustomMenu}>
                              {this.props.patient.otherAbhaAddresses.map(
                                (address, index) => {
                                  return (
                                    <p
                                      className="secondary-site-tooltip-item"
                                      key={index}
                                    >
                                      {address}
                                    </p>
                                  );
                                }
                              )}
                            </Dropdown.Menu>
                          </Dropdown>
                        </span>
                      );
                    }
                  })()}
                </span>
              </div>
              <div>
                ABHA Number:{" "}
                <span className="new-exam-details-value">
                  {this.props.patient.abhaNumber}
                </span>
              </div>
              <div>
                Address:{" "}
                <span className="new-exam-details-value">
                  {this.props.patient.address}
                </span>
              </div>
              <div>
                District:{" "}
                <span className="new-exam-details-value">
                  {this.props.patient.district}
                </span>
              </div>
              <div>
                State:{" "}
                <span className="new-exam-details-value">
                  {this.props.patient.state}
                </span>
              </div>
              <div>
                Pin Code:{" "}
                <span className="new-exam-details-value">
                  {this.props.patient.pinCode}
                </span>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default withTranslation()(CustomABHAModal);
